import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const SnackbarInfoIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 40 40" data-test-id='snackbar-info-icon'>
      <circle cx='20' cy='20' r='20' className='outline' />
      <circle cx='20' cy='20' r='15' className='background' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20 15.4167C21.1506 15.4167 22.0834 14.4839 22.0834 13.3333C22.0834 12.1827 21.1506 11.25 20 11.25C18.8494 11.25 17.9167 12.1827 17.9167 13.3333C17.9167 14.4839 18.8494 15.4167 20 15.4167ZM20 28.75C21.1506 28.75 22.0834 27.8173 22.0834 26.6667L22.0834 19.1667C22.0834 18.0161 21.1506 17.0833 20 17.0833C18.8494 17.0833 17.9167 18.0161 17.9167 19.1667L17.9167 26.6667C17.9167 27.8173 18.8494 28.75 20 28.75Z'
        className='content'
      />
    </SvgIcon>
  );
};

export default SnackbarInfoIcon;
